import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'

const responseSchema = z.array(
  z.object({
    id: z.string(),
    table_key: z.string(),
    hidden_columns: z.array(z.string())
  })
)

type HiddenColumns = {
  id: string
  tableKey: string
  hiddenColumns: string[]
}

const parseResponse = (
  response: z.infer<typeof responseSchema>
): HiddenColumns[] =>
  response.map(item => ({
    id: item.id,
    hiddenColumns: item.hidden_columns,
    tableKey: item.table_key
  }))

const useHiddenColumns = () =>
  useQuery({
    queryKey: ['hiddenColumns'],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelUsersTablePreferencesList({
        page_size: 'max'
      })
      return parseResponse(responseSchema.parse(response.results))
    }
  })

export default useHiddenColumns
